// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { CFDI_PREVIEW_ENDPOINT } from '../../../../../../../utility/SourceAPI'
import { formattedDatePicker } from '../../../../../../../utility/formats/formattedDate'

const config = {
    headers: {
        'Content-Type': 'multipart/form-data;boundary=boundary'
    }
}

export const readXMLPreview = createAsyncThunk('appFoliosPrevios/readXMLPreview', async (data) => {
    const response = await axios.post(CFDI_PREVIEW_ENDPOINT.concat('readxml'), data, config)
    return {
        data: response.data
    }
})

export const getFoliosPrevios = createAsyncThunk('appFoliosPrevios/getFoliosPrevios', async (data) => {
    let params = {}
    if (data?.emisor_rfc?.length > 0) {
        params = { ...params, emisor_rfc: data.emisor_rfc }
    }
    if (data?.intermediario?.length > 0) {
        params = { ...params, intermediario_id: data.intermediario }
    }
    if (data?.receptor_rfc?.length > 0) {
        params = { ...params, receptor_rfc: data.receptor_rfc }
    }
    if (data?.status !== undefined && data?.status !== '') {
        params = { ...params, status_cfdi: data.status }
    }
    const queryString = Object.keys(params)
        .map(key => {
            const values = Array.isArray(params[key]) ? params[key] : [params[key]]
            return values.map(value => `${key}=${encodeURIComponent(value)}`).join('&')
        })
        .join('&')
    const url = `${CFDI_PREVIEW_ENDPOINT}${queryString ? `?${queryString}` : ''}`
    const response = data?.rangeDates?.start ? await axios.get(url.concat(`${queryString ? '&' : '?'}end=${formattedDatePicker(data.rangeDates.end)}&start=${formattedDatePicker(data.rangeDates.start)}`)) : await axios.get(url)
    return {
        data: response.data
    }
})

export const addFolioPrevio = createAsyncThunk('appFoliosPrevios/addFolioPrevio', async (data, { dispatch }) => {
    const response = await axios.post(CFDI_PREVIEW_ENDPOINT, data)
    await dispatch(getFoliosPrevios())
    return {
        data: response.data
    }
})

export const updateFolioPrevio = createAsyncThunk('appFoliosPrevios/updateFolioPrevio', async (data, { dispatch }) => {
    const response = await axios.put(CFDI_PREVIEW_ENDPOINT.concat(`update_intermediary${data.id}`), data)
    await dispatch(getFoliosPrevios())
    return {
        data: response.data
    }
})

export const cancellFolioPrevio = createAsyncThunk('appFoliosPrevios/cancellFolioPrevio', async (data, { dispatch }) => {
    const response = await axios.put(CFDI_PREVIEW_ENDPOINT.concat(`cancelled/${data.id}`), data)
    await dispatch(getFoliosPrevios())
    return {
        data: response.data
    }
})

export const appFoliosPreviosSlice = createSlice({
    name: 'appFoliosPrevios',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getFoliosPrevios.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
    }
})

export default appFoliosPreviosSlice.reducer
